import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/index.vue";
import Settings from "@/views/settings/index.vue";
import Login from "@/views/login/index.vue";
import idCardBinding from "@/views/idCardBinding/index.vue"
import loan from "@/views/loan/index.vue"
import addBank from "@/views/addBank/index.vue"
import bankCardBinding from "@/views/bankCardBinding/index.vue"
import orderDetails from "@/views/orderDetails/index.vue"
import agreement from "@/views/agreement/index.vue"
import orderList from "@/views/orderList/index.vue"
import landingPage from "@/views/landingPage/index.vue"
import feedBack from "@/views/feedBack/index.vue"
import notify from "@/views/notify/index.vue"
import applicationList from "@/views/applicationList/index.vue"
import selectBankCard from "@/views/selectBankCard/index.vue"
import result from "@/views/idCardBinding/result.vue"
import accountsAndSecurity from "@/views/accountsAndSecurity/index.vue"
import landingPageResule from "@/views/landingPage/landingPageResule.vue"
import submitSign from "@/views/submitSign/index.vue"
import selectBank from "@/views/selectBank/index.vue"
import appAgreement from "@/views/appAgreement/index.vue"
import store from "@/store";
import idCardLoading from "@/views/idCardLoading/index.vue";
import idCardLoadingApp from "@/views/idCardLoadingApp/index.vue";
import loadAgreement from "@/views/loadAgreement/index.vue";
import quickLoan from "@/views/quickLoan/index.vue";
Vue.use(VueRouter);
let _isProgrammaticNav = false;
let _isPhysicalBack = false;

const _markProgrammaticNav = () => {
  _isProgrammaticNav = true;
  setTimeout(() => {
    _isProgrammaticNav = false;
  }, 0);
};

const _markPhysicalBack = () => {
  if (_isProgrammaticNav) return;
  _isPhysicalBack = true;
  setTimeout(() => {
    _isPhysicalBack = false;
  }, 50);
};

window.addEventListener("popstate", _markPhysicalBack);
window.addEventListener("hashchange", _markPhysicalBack);
// 1. 先保存一份原有的 push 和 replace 原型方法
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace

// 2. 重写 push 方法，并在其内部的 catch 中拦截并吞掉同名路由跳转的错误
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  _markProgrammaticNav();
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => {
    // 如果是由于重复导航引起的错误，直接安全熔断，不报错
    if (VueRouter.isNavigationFailure(err)) return err;
    return Promise.reject(err);
  })
}

// 3. 重写 replace 方法（同理）
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  _markProgrammaticNav();
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => {
    if (VueRouter.isNavigationFailure(err)) return err;
    return Promise.reject(err);
  })
}
const routes = [
  {
    path: "/home",
    name: "Home",
    component: Home,
    // 首页是 Vant 默认蓝
    meta: { statusBarBg: '#0d63ef' },
    
  },
  {
    path: "/settings",
    name: "Settings",
    component: Settings,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: { keepAlive: true },
  },
  {
    path: "/idCardBinding",
    name: "idCardBinding",
    component: idCardBinding,
    meta: { keepAlive: true },
  },
  {
    path: "/loan",
    name: "loan",
    component: loan,
    meta: { keepAlive: true, physicalBackTo: { name: "Home" }, statusBarBg: '#0d63ef' },
  },
  {
    path: "/addBank",
    name: "addBank",
    component: addBank,
  },
  {
    path: "/bankCardBinding",
    name: "bankCardBinding",
    component: bankCardBinding,
    meta: { keepAlive: true },
  },
  {
    path: "/orderDetails",
    name: "orderDetails",
    component: orderDetails,
    meta: { keepAlive: true },
  },
  {
    path: "/agreement",
    name: "agreement",
    component: agreement,
  },
  {
    path: "/orderList",
    name: "orderList",
    component: orderList,
  },
  {
    path: "/landingPage",
    name: "landingPage",
    component: landingPage,
    meta: { keepAlive: true },
  },
  {
    path: "/feedBack",
    name: "feedBack",
    component: feedBack,
  },
  {
    path: "/notify",
    name: "notify",
    component: notify,
  },
  {
    path: "/applicationList",
    name: "applicationList",
    component: applicationList,
  },
  {
    path: "/selectBankCard",
    name: "selectBankCard",
    component: selectBankCard,
  },
  {
    path: "/result",
    name: "result",
    component: result,
  },
  {
    path: "/accountsAndSecurity",
    name: "accountsAndSecurity",
    component: accountsAndSecurity,
  },
  {
    path: "/landingPageResule",
    name: "landingPageResule",
    component: landingPageResule,
  },
  {
    path: "/submitSign",
    name: "submitSign",
    component: submitSign,
  },
  {
    path: "/selectBank",
    name: "selectBank",
    component: selectBank,
  },
  {
    path: "/appAgreement",
    name: "appAgreement",
    component: appAgreement,
  },
  {
    path: "/idCardLoading",
    name: "idCardLoading",
    component: idCardLoading,
  },
  {
    path: "/idCardLoadingApp",
    name: "idCardLoadingApp",
    component: idCardLoadingApp,
  },
  {
    path: "/contractAgreement",
    name: "contractAgreement",
    component: () => import('@/views/orderDetails/contractAgreement.vue'),
  },
  {
    path: "/loadAgreement",
    name: "loadAgreement",
    component: loadAgreement,
  },
  {
    path: "/quickLoan",
    name: "quickLoan",
    component: quickLoan,
    meta: { keepAlive: true },
  },
];

const router = new VueRouter({
  routes,
});
router.beforeEach((to, from, next) => {
  // 1. 获取当前页面配置的颜色，如果没有配置，则给一个全局默认颜色（比如白色）
  const bgColor = to.meta.statusBarBg || '#ffffff';
  // 2. 动态修改全局 CSS 变量
  document.documentElement?.style?.setProperty?.('--status-bar-bg', bgColor);
  if (_isPhysicalBack && from?.meta?.physicalBackTo) {
    _isPhysicalBack = false;
    next(from.meta.physicalBackTo);
    return;
  }
  const whiteList = new Set([
    "Login",
    "landingPage",
    "landingPageResule",
    "appAgreement",
    "agreement",
    "quickLoan",
  ]);
  const cachedToken = localStorage.getItem("token") || "";
  if (!store.state.token && cachedToken) {
    store.commit("setToken", cachedToken);
  } else if (store.state.token && store.state.token !== cachedToken) {
    localStorage.setItem("token", store.state.token);
  }
  const hasToken = !!store.state.token;

  if (_isPhysicalBack) {
    _isPhysicalBack = false;

    if (from?.name === "appAgreement" || from?.name === "landingPage" || from?.name === "landingPageResule") {
      next(false);
      setTimeout(() => {
        router.replace(from.fullPath).catch(() => { });
      }, 0);
      return;
    }

    if (!hasToken && !whiteList.has(to.name)) {
      next({
        name: "Login",
        query: { redirect: to.fullPath },
      });
      return;
    }

    if (from?.meta?.physicalBackTo) {
      next(from.meta.physicalBackTo);
      return;
    }
  }


  if (hasToken && to.name === "Login") {
    console.log("hasToken", hasToken);
    next({ name: "Home" });
    return;
  }

  if (to.path === from.path) {
    // 阻止导航并显示一条消息
    console.log("尝试导航到当前页面，已避免重复导航");
    // 可以通过某种方式通知用户，例如显示一个提示框
    next(false);
    return;
  }
  next(); // 确保继续执行导航
});
export default router;
